'use strict';

/*
  Fiche produit : compatibilite avec « Mon appareil » et contexte du devis.

  31/10 (lot fiche, parcours mobile du pilote) : UNE seule ligne de compatibilite en tete
  de fiche, au lieu de « Compatible avec : ... » + « Compatible avec votre modèle : ... ».
    - appareil memorise dans la liste : « Compatible avec votre Lotus Liva 6 », les autres
      modeles replies (« et 2 autres modèles ») ;
    - appareil memorise hors de la liste : « N'est pas indiqué pour votre Lotus X » (ou
      « Ne convient pas » si l'incompatibilite est documentee) et le lien vers les pieces
      de son modele ;
    - sans appareil : « Compatible avec : A, B » et la suite repliee au-dela de 2.
  La liste vient de la fiche (fitment_json, #k-pdp-compat-data), jamais d'une liste en dur.
  Le recapitulatif du tiroir de devis suit le meme appareil.
*/
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') api.init();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function readCompatData() {
    var el = document.getElementById('k-pdp-compat-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function deviceFullLabel(device) {
    var deviceLabel = device && device.model_label ? device.model_label : '';
    var brandLabel = device && device.brand_label ? device.brand_label : '';
    return (brandLabel + ' ' + deviceLabel).replace(/\s+/g, ' ').trim();
  }

  function normalize(text) {
    return String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function plusModeles(n) {
    return 'et ' + n + (n === 1 ? ' autre modèle' : ' autres modèles');
  }

  // Vue pure (testee sous Node) : ce que dit la ligne de compatibilite.
  function compatView(state, device, data) {
    data = data || {};
    var models = Array.isArray(data.models) ? data.models.filter(function (m) { return m && m.label; }) : [];
    if (!models.length) return null;
    var label = deviceFullLabel(device);

    if (device && label && state === 'compatible') {
      var autres = models.filter(function (m) {
        return m.handle ? m.handle !== device.model_handle : normalize(m.label) !== normalize(label);
      });
      var conditions = data.compatible_conditions || {};
      return {
        kind: 'ok',
        texte: 'Compatible avec votre ' + label,
        condition: conditions[device.model_handle] || '',
        lien: null,
        resume: autres.length ? plusModeles(autres.length) : '',
        autres: autres
      };
    }

    if (device && label && (state === 'incompatible' || state === 'unknown')) {
      return {
        kind: 'non',
        texte: (state === 'incompatible' ? 'Ne convient pas à votre ' : 'N’est pas indiqué pour votre ') + label,
        condition: '',
        lien: device.model_handle ? { texte: 'Voir les pièces de votre ' + label, url: '/collections/model-' + device.model_handle } : null,
        resume: models.length === 1 ? 'Modèle indiqué : ' + models[0].label : 'Voir les ' + models.length + ' modèles indiqués',
        autres: models.length === 1 ? [] : models
      };
    }

    // Sans appareil (ou verdict en conflit) : la liste de la fiche, repliee au-dela de 2.
    return {
      kind: 'liste',
      texte: 'Compatible avec : ' + models.slice(0, 2).map(function (m) { return m.label; }).join(', '),
      condition: '',
      lien: null,
      resume: models.length > 2 ? plusModeles(models.length - 2) : '',
      autres: models.slice(2)
    };
  }

  // Texte du recapitulatif du devis pour le modele : « · pour votre Lotus Liva 6 ».
  function recapModele(model, isDevice) {
    return model ? ' · pour ' + (isDevice ? 'votre ' : '') + model : '';
  }

  function icone(kind) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var circle = document.createElementNS(SVG_NS, 'circle');
    circle.setAttribute('cx', '12');
    circle.setAttribute('cy', '12');
    circle.setAttribute('r', '9');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', kind === 'ok' ? 'm8.5 12.5 2.2 2.2 4.8-5.2' : 'M12 8v5M12 16.5h.01');
    svg.appendChild(circle);
    svg.appendChild(path);
    return svg;
  }

  function render(container, view) {
    if (!container || !view) return;
    while (container.firstChild) container.removeChild(container.firstChild);

    var ligne = document.createElement('p');
    ligne.className = 'k-pdp-fiche__compat-ligne' + (view.kind === 'liste' ? '' : ' k-pdp-fiche__compat-ligne--' + view.kind);
    ligne.setAttribute('data-k-pdp-compat-ligne', '');
    if (view.kind !== 'liste') ligne.appendChild(icone(view.kind));
    var corps = document.createElement('span');
    var texte = document.createElement('span');
    // Un numero de modele ne reste jamais seul en debut de ligne (« Liva » / « 6 ») :
    // espace insecable avant le dernier mot, sans empecher les noms longs de passer a la ligne.
    texte.textContent = view.kind === 'liste' ? view.texte : view.texte.replace(/ (\S{1,4})$/, '\u00a0$1');
    corps.appendChild(texte);
    if (view.condition) {
      // Condition constructeur (ex. « avant le n° de série 100623 ») : jamais de
      // « compatible » sans elle.
      var cond = document.createElement('span');
      cond.className = 'k-pdp-fiche__compat-condition';
      cond.textContent = '(' + view.condition + '). Vérifiez la plaque signalétique de votre appareil.';
      corps.appendChild(cond);
    }
    ligne.appendChild(corps);
    container.appendChild(ligne);

    if (view.lien) {
      var a = document.createElement('a');
      a.className = 'k-b3 k-pdp-fiche__compat-lien';
      a.href = view.lien.url;
      a.textContent = view.lien.texte;
      container.appendChild(a);
    }

    if (view.resume && view.autres.length) {
      var details = document.createElement('details');
      details.className = 'k-pdp-fiche__compat-plus';
      details.setAttribute('data-k-pdp-compat-plus', '');
      var summary = document.createElement('summary');
      summary.textContent = view.resume;
      details.appendChild(summary);
      var ul = document.createElement('ul');
      ul.setAttribute('role', 'list');
      view.autres.forEach(function (m) {
        var li = document.createElement('li');
        if (m.url) {
          var lien = document.createElement('a');
          lien.href = m.url;
          lien.textContent = m.label;
          li.appendChild(lien);
        } else {
          li.textContent = m.label;
        }
        ul.appendChild(li);
      });
      details.appendChild(ul);
      container.appendChild(details);
    } else if (view.resume) {
      var seul = document.createElement('p');
      seul.className = 'k-pdp-fiche__compat-ligne';
      seul.textContent = view.resume;
      container.appendChild(seul);
    }
  }

  function setQuoteField(name, value) {
    var field = document.querySelector('.k-quote-modal__form input[name="' + name + '"]');
    if (field) field.value = value || '';
  }

  function majRecap(model, isDevice) {
    var span = document.querySelector('[data-k-quote-recap-modele]');
    if (span) span.textContent = recapModele(model, isDevice);
    var champ = document.querySelector('[data-k-quote-modele-champ]');
    if (champ) champ.hidden = !!model;
  }

  function applyQuoteContext(state, device, data, ssrModel) {
    if (!data || data.autonome === true) return;
    var label = deviceFullLabel(device);

    if (data.multi_model !== true) {
      // Fiche d'un seul modele : son modele part tel quel (rendu serveur) ; avec un
      // appareil compatible, le recapitulatif dit « pour votre ... ».
      majRecap(ssrModel, state === 'compatible' && !!device);
      return;
    }

    setQuoteField('contact[model]', '');
    setQuoteField('contact[schema]', '');
    setQuoteField('contact[position]', '');

    if (!device || !label) {
      majRecap('', false);
      return;
    }

    // Appareil connu : son modele part avec la demande, meme hors de la liste (l'equipe
    // verifie) ; le schema et le repere seulement s'il est compatible et sans ambiguite.
    setQuoteField('contact[model]', label);
    majRecap(label, true);
    if (state !== 'compatible') return;

    var occurrences = Array.isArray(data.quote_occurrences) ? data.quote_occurrences : [];
    var seen = {};
    var unique = [];
    occurrences.forEach(function (occ) {
      if (!occ || occ.model_handle !== device.model_handle || !occ.has_exploded_view) return;
      var schema = occ.schema_number === null || occ.schema_number === undefined ? '' : String(occ.schema_number);
      var position = occ.position_label === null || occ.position_label === undefined ? '' : String(occ.position_label);
      if (!schema) return;
      var key = schema + '|' + position;
      if (seen[key]) return;
      seen[key] = true;
      unique.push({ schema: schema, position: position });
    });

    if (unique.length === 1) {
      setQuoteField('contact[schema]', unique[0].schema);
      setQuoteField('contact[position]', unique[0].position);
    }
  }

  function init() {
    var KDM = window.KrepiteDeviceMemory;
    if (!KDM) return;
    var container = document.querySelector('[data-k-pdp-compat]');
    var data = readCompatData();
    var modelInput = document.querySelector('.k-quote-modal__form input[name="contact[model]"]');
    var ssrModel = modelInput ? modelInput.value : '';

    function evaluate() {
      var device = KDM.get();
      var result = KDM.resolveCompat(device, data);
      render(container, compatView(result.state, device, data));
      applyQuoteContext(result.state, device, data, ssrModel);
    }

    evaluate();
    KDM.subscribe(evaluate);
  }

  return {
    compatView: compatView,
    recapModele: recapModele,
    init: function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      else init();
    }
  };
});
